import { BarChart, Bar, PieChart, Pie, Cell, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

const CORES_PIZZA = ["#ef4444","#f59e0b","#10b981","#0ea5e9","#6366f1","#8b5cf6","#ec4899","#14b8a6","#f97316","#64748b"];
const fmtBR = (v) => `R$${Number(v||0).toLocaleString("pt-BR",{minimumFractionDigits:0})}`;

export default function DashboardFinanceiro({ resumo, theme }) {
  if (!resumo) return <div style={{ padding:40, textAlign:"center", color:theme.textMuted }}>Carregando dados...</div>;

  const card = { background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:16, padding:22, boxShadow:"0 1px 3px rgba(0,0,0,.05)" };
  const titulo = { fontSize:14, fontWeight:700, color:theme.text, marginBottom:18, display:"flex", alignItems:"center", gap:8 };

  const kpis = [
    { label:"Lucro Líquido", valor:resumo.lucroLiquido, icone:"💰", cor: resumo.lucroLiquido>=0 ? "#10b981" : "#ef4444" },
    { label:"A Receber",     valor:resumo.aReceber,     icone:"📥", cor:"#0ea5e9" },
    { label:"A Pagar",       valor:resumo.aPagar,       icone:"📤", cor:"#f59e0b" },
    { label:"Vencidas",      valor:resumo.valorVencido, icone:"⚠️", cor:"#ef4444", sub:`${resumo.totalVencidos||0} conta(s)` },
  ];

  const dadosVisao = [
    { nome:"Entradas", valor:resumo.totalEntradas||0, fill:"#10b981" },
    { nome:"Saídas",   valor:resumo.totalSaidas||0,   fill:"#ef4444" },
    { nome:"Recebido", valor:resumo.totalRecebido||0, fill:"#34d399" },
    { nome:"Pago",     valor:resumo.totalPago||0,     fill:"#f87171" },
  ];

  const dadosCategorias = Object.entries(resumo.categorias||{}).map(([nome,valor])=>({nome,valor})).sort((a,b)=>b.valor-a.valor);

  return (
    <div style={{ padding:"4px 0" }}>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap:14, marginBottom:18 }}>
        {kpis.map((k,i)=>(
          <div key={i} style={{ background:`linear-gradient(135deg, ${k.cor}18, ${k.cor}08)`, border:`1px solid ${k.cor}33`, borderRadius:16, padding:"18px 20px", boxShadow:"0 1px 3px rgba(0,0,0,.05)" }}>
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:10 }}>
              <span style={{ fontSize:11, color:theme.textMuted, fontWeight:700, textTransform:"uppercase", letterSpacing:".05em" }}>{k.label}</span>
              <span style={{ fontSize:20 }}>{k.icone}</span>
            </div>
            <div style={{ fontSize:24, fontWeight:800, color:k.cor }}>{fmtBR(k.valor)}</div>
            {k.sub && <div style={{ fontSize:12, color:theme.textMuted, marginTop:2 }}>{k.sub}</div>}
          </div>
        ))}
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <div style={card}>
          <div style={titulo}>📊 Visão geral</div>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={dadosVisao}>
              <CartesianGrid strokeDasharray="3 3" stroke={theme.border} vertical={false} />
              <XAxis dataKey="nome" tick={{ fill:theme.textMuted, fontSize:12 }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill:theme.textMuted, fontSize:11 }} tickFormatter={fmtBR} width={70} axisLine={false} tickLine={false} />
              <Tooltip formatter={(v)=>fmtBR(v)} cursor={{ fill:theme.bgInput }} contentStyle={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:10, color:theme.text }} />
              <Bar dataKey="valor" radius={[8,8,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div style={card}>
          <div style={titulo}>🥧 Despesas por categoria</div>
          {dadosCategorias.length===0 ? (
            <div style={{ padding:40, textAlign:"center", color:theme.textMuted, fontSize:13 }}>Nenhuma despesa no período.</div>
          ) : (
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie data={dadosCategorias} dataKey="valor" nameKey="nome" cx="50%" cy="50%" innerRadius={55} outerRadius={95} paddingAngle={2}>
                  {dadosCategorias.map((d,i)=><Cell key={i} fill={CORES_PIZZA[i%CORES_PIZZA.length]} stroke={theme.bgCard} strokeWidth={2} />)}
                </Pie>
                <Tooltip formatter={(v)=>fmtBR(v)} contentStyle={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:10, color:theme.text }} />
                <Legend wrapperStyle={{ fontSize:11, color:theme.textMuted }} />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>

      <div style={card}>
        <div style={titulo}>📈 Evolução mensal (6 meses)</div>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={resumo.fluxoMensal||[]}>
            <CartesianGrid strokeDasharray="3 3" stroke={theme.border} vertical={false} />
            <XAxis dataKey="label" tick={{ fill:theme.textMuted, fontSize:12 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill:theme.textMuted, fontSize:11 }} tickFormatter={fmtBR} width={70} axisLine={false} tickLine={false} />
            <Tooltip formatter={(v)=>fmtBR(v)} contentStyle={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:10, color:theme.text }} />
            <Legend wrapperStyle={{ fontSize:12 }} />
            <Line type="monotone" dataKey="entradas" name="Entradas" stroke="#10b981" strokeWidth={3} dot={{ r:4, fill:"#10b981" }} activeDot={{ r:6 }} />
            <Line type="monotone" dataKey="saidas" name="Saídas" stroke="#ef4444" strokeWidth={3} dot={{ r:4, fill:"#ef4444" }} activeDot={{ r:6 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
